<template>
  <div class="categoryRapper lastpage_wrap">
    <header ref="header">
      <div>
        <img v-show="isShowBackBtn" src="~assets/images/game/return.png" alt @click="returnpage" />
      </div>
      <span>{{titleName}}</span>
      <div>
        <!-- <img src="~assets/images/game/search.png" alt=""> -->
      </div>
    </header>
    <div class="content" ref="contentNode">
      <swiper
        ref="mySwiper"
        v-if="!!swiperSlides"
        :options="swiperOption"
        class="banner"
        :class="{'banner-anim': isBannerAnim }"
      >
        <swiper-slide
          v-for="slide in swiperSlides"
          :key="slide.id"
          style="width:3.42rem;height:1.33rem;"
        >
          <img
            v-lazy="slide.imageUrl"
            :key="slide.imageUrl"
            :data-jumpUrl="slide.ctaUrl"
            style="width:100%;height:100%;border-radius:0.13rem;"
            alt
          />
        </swiper-slide>
      </swiper>
      <div class="gameBox" ref="gameBoxNode" :class="{listAni:sortShow}">
        <div class="gameTypeBox">
          <div class="gameList">
            <ul class="category" ref="category">
              <li
                v-for="(category,index) in tagsList"
                :key="category.id"
                :class="{categoryActive:choosedCategory == index}"
                @click="changeCategory(index,category.id,category.tags)"
                :ref="category.id"
              >
                {{category.name}}
                <span class="chooseLine"></span>
              </li>
            </ul>
          </div>
          <div class="gradual"></div>
          <div class="listImg" v-if="tagsList" @click="moreList">
            <img src="~assets/images/game/more.png" alt />
          </div>
        </div>
      </div>
      <div class="empty" ref="empty"></div>
      <ul class="sortList" ref="sortList">
        <li
          v-for="(tagName,index) in sortList"
          :key="index"
          :class="{tagActive:choosedSortType == index}"
          @click="sortType(index)"
        >{{tagName}}</li>
        <!-- <li :class="{tagActive:choosedPkgType}" class="pkgLi" @click.stop="clickPkg">{{choosedPkg}}
          <img v-lazy="choosedPkgType ? upArrow : downGrayArrow" :key="choosedPkgType ? upArrow : downGrayArrow" alt="">
        </li>-->
        <div class="shade" v-if="isShade" @click="switchModal"></div>
        <!-- <div class="chooseSize" v-if="isSizeShow">
          <ul>
            <li v-for="(pkg,index) in pkgSize" :key="index" @click.stop="changePkg(pkg)" :class="{chooseSizeActive:choosedPkg == pkg}">{{pkg}}</li>
          </ul>
        </div>-->
      </ul>
      <div
        class="gameListBox"
        @touchstart="gameListTouchstart"
        @touchmove="gameListTouchmove"
        @touchend="gameListTouchend"
        @scroll="scrollEvent"
        ref="gameListBoxNode"
      >
        <gamelist ref="gameItem" v-for="game in gameList" :key="game.id" :game="game" from="category"></gamelist>
      </div>
    </div>
    <ul class="sortList" v-if="stickyActive">
      <li
        v-for="(tagName,index) in sortList"
        :key="index"
        :class="{tagActive:choosedSortType == index}"
        @click="sortType(index)"
      >{{tagName}}</li>
      <li :class="{tagActive:choosedPkgType}" @click.stop="clickPkgFloat">
        {{choosedPkg}}
        <img
          v-lazy="choosedPkgType ? upArrow : downGrayArrow"
          :key="choosedPkgType ? upArrow : downGrayArrow"
          alt
        />
      </li>
      <div class="shade" v-if="isShade" @click="switchModal"></div>
      <div class="chooseSize" v-if="isSizeShowFloat">
        <ul>
          <li
            v-for="(pkg,index) in pkgSize"
            :key="index"
            @click.stop="changePkg(pkg)"
            :class="{chooseSizeActive:choosedPkg == pkg}"
          >{{pkg}}</li>
        </ul>
      </div>
    </ul>
    <div class="closePkgModal" v-if="isModalShow" @touchstart="switchModal"></div>
    <div class="moreList" v-if="isMoreListShow">
      <div class="modal" @click="closeListModal"></div>
      <div class="moreChoose">
        <h3>{{titleName}}</h3>
        <ul class="category">
          <li
            v-for="(category,index) in tagsList"
            :key="category.id"
            :class="{categoryActive:choosedCategory == index}"
            @click="changeCategory(index,category.id,category.tags)"
          >{{category.name}}</li>
        </ul>
      </div>
    </div>
    <Toast :toastContent="toastContent" ref="myToast"></Toast>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import gamelist from "@/components/gamebox/gamelist.vue";
import "swiper/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Toast from "@/components/withdraw/toast";
import { androidMethod, changeResId, goBack, gotoServerGameDetail, getUrlParam } from "@/utils/base";
export default {
  data() {
    let that = this;
    return {
      isShowBackBtn: true,
      downGrayArrow: require("../../assets/images/game/downGrayArrow.png"),
      downOrangeArrow: require("../../assets/images/game/downOrangeArrow.png"),
      upArrow: require("../../assets/images/game/upArrow.png"),
      tagId: "27", //上一个页面传过来，url上获取
      tags: 0, //选择展示哪个类型
      sort: 1, //默认是1推荐，2最热，3最新
      titleName: "分类", //大标题
      tagsList: null, //标签列表
      sortShow: false,
      gameList: [], //游戏列表
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        on: {
          click: function(e) {
            let url = e.target.dataset.jumpurl;
            that.jumpUrl(url);
          }
        }
      },
      swiperSlides: null, //bannner图片
      sortList: ["推荐", "最热", "最新"],
      pkg: "",
      pkgSize: [
        "全部大小",
        "20M以下",
        "20-50M",
        "50-100M",
        "100-500M",
        "500M以上"
      ],
      choosedPkg: "全部大小",
      isSizeShow: false, //选择包大小的框
      isSizeShowFloat: false,
      choosedCategory: 0,
      choosedSortType: 0,
      choosedPkgType: false,
      isShade: false,
      isModalShow: false,
      isMoreListShow: false,
      stickyActive: false, //固定
      uuid: "",
      toastContent: "", //toast的提示信息
      touchStartPos: 0,
      touchEndPos: 0,
      touchHeaderPos: 0,
      isBannerAnim: false,
      resId: {
        categoryID: 0,
        gameId: "",
        param1: 0,
        param2: 0,
        paramExtra: "",
        reqId: "",
        source: 0,
      },
      screenHeight: 0,
      headerHeight: 0,
      gameHeight: 0,
      index: 0, // 游戏位置
      gameIndex: 0, // 已经展示几个
    };
  },
  components: {
    swiper,
    swiperSlide,
    gamelist,
    Toast
  },
  filters: {
    handleDownload: function(value) {
      if (value >= 10000) {
        return Math.ceil(value / 10000) + "万+";
      }
      return value + "次";
    },
    handlePkgSize: function(value) {
      return Math.floor(value * 100) / 100 + "M";
    }
  },
  created() {
    androidMethod('setStatusColor','','1','#fff');
    androidMethod('setStatusMode', '', "true");
    // this.uuid = '963af46a328d43349ab3ab296d208283'
    this.uuid = androidMethod("getUserUUID", "");
    let search = window.location.search.substring(1).split("&");
    this.tagId = search[0].split("=")[1];
    this.tags = search[1].split("=")[1];
    // 获取上个页面的resId
    const resId = androidMethod("getResId", "");
    if (typeof resId === "string") {
      this.resId = JSON.parse(resId);
    }

    // 传入地址栏上的tagId
    // /apiserv/qTLN2Nec/Frontend/Classify/V2/TagsAndBanner?tagId=${this.tagId}
    //     this.$http.post(`http://easymock.233wei.cn/mock/5e3919a47967af073af3f84a/qTLN2Nec/Frontend/Classify/V2/TagsAndBanner#!method=post
    // `).then(res => {
    this.$http
      .post(
        `/apiserv/qTLN2Nec/Frontend/Classify/V2/TagsAndBanner?tagId=${this.tagId}`
      )
      .then(res => {
        if (res.data.return_code == 200) {
          this.swiperSlides = res.data.data.banner;
          const listNum = Cookies.get(
            `category_ui_scroll_${window.location.href}`
          );
          if (listNum == 0) {
            this.isBannerAnim = true;
          }
          this.$refs.contentNode.scrollTop = 0;
          this.$refs.gameListBoxNode.scrollTop = listNum;
          this.titleName = res.data.data.name;
          this.tagsList = res.data.data.tags;
          // 根据安卓给的tags判断是第几个,直接选中某个分类
          if (this.tagsList) {
            this.tagsList.forEach((value, index) => {
              if (this.tagsList[index].tags == this.tags) {
                this.choosedCategory = index;
              }
            });
          } else {
            this.sortShow = true;
          }
        }
      });
    // 传入sortType, tags, pageIndex, pageSize
    this.getLists();
    window["hideBack"] = () => {
      this.isShowBackBtn = false;
    };
  },
  updated() {
    const listNum = Cookies.get(`category_ui_scroll_${window.location.href}`);
    if (listNum != 0) {
      let swiperHeight;
      if (this.$refs.mySwiper) {
        swiperHeight = this.$refs.mySwiper.$el.clientHeight;
      }
      const tScrollHeight = swiperHeight
        ? swiperHeight
        : 0 + this.$refs.gameBoxNode.clientHeight;
      this.$refs.contentNode.scrollTop = tScrollHeight;
      this.$refs.gameListBoxNode.scrollTop = listNum;
      // this.$refs.contentNode.scrollTo(0, tScrollHeight);
      // this.$refs.gameListBoxNode.scrollTo(0, listNum);
      const sortType = Cookies.get("category_ui_sortType");
      if (sortType != undefined) {
        this.choosedSortType = sortType - 1;
      }
    }
  },
  methods: {
    gameListTouchend(e) {
      console.log("gameListTouchend", this.$refs.contentNode.scrollTop);
      let swiperHeight;
      if (this.$refs.mySwiper) {
        swiperHeight = this.$refs.mySwiper.$el.clientHeight;
      }
      const tScrollHeight = swiperHeight
        ? swiperHeight
        : 0 + this.$refs.gameBoxNode.clientHeight;
      const tScrollTop = this.$refs.contentNode.scrollTop;
      if (tScrollTop < tScrollHeight) {
        if (tScrollTop > tScrollHeight / 2) {
          this.$refs.contentNode.scrollTop = tScrollHeight;
          // this.$refs.contentNode.scrollTo(0, tScrollHeight);
        } else {
          Cookies.set(`category_ui_scroll_${window.location.href}`, 0, {
            expires: 1 / 480
          });
          this.$refs.contentNode.scrollTop = 0;
        }
      }
    },
    jumpDetail(game) {
      const params = { ...this.resId, paramExtra: game.index, gameId: game.id.toString() };
      collect('item_click', changeResId(params), '分类页')
      androidMethod("setResId", "", JSON.stringify(params));
      var res = androidMethod("openGameDetail", "", JSON.stringify(game),JSON.stringify(params))
      if(res.code == 404){
        gotoServerGameDetail({ gameId: game.id })
      }
    },
    gameListTouchstart(e) {
      const sY = e.touches[0].clientY;
      this.touchStartPos = sY;
      if (e.touches.length > 1) {
        return;
      }
      this.touchEndPos = sY;
    },
    gameListTouchmove(e) {
      const sY = e.touches[0].clientY;
      if (e.touches.length > 1) {
        return;
      }
      let swiperHeight;
      if (this.$refs.mySwiper) {
        swiperHeight = this.$refs.mySwiper.$el.clientHeight;
      }
      const tScrollHeight = swiperHeight
        ? swiperHeight
        : 0 + this.$refs.gameBoxNode.clientHeight;
      const tScrollTop = this.$refs.contentNode.scrollTop;
      if (tScrollTop < tScrollHeight) {
        const diffY = sY - this.touchStartPos;
        if (this.touchEndPos > sY) {
          e.preventDefault();
          this.$refs.contentNode.scrollTop = this.touchHeaderPos - diffY;
          // this.$refs.contentNode.scrollTo(0, this.touchHeaderPos - diffY);
        }
      }
      this.touchEndPos = sY;
    },
    returnpage() {
      var jumptype = getUrlParam("jumptype");
      if (jumptype == "search") {
        var el = document.querySelector(".lastpage_wrap");
        el.style.display = "none";
      }
      goBack();
    },
    jumpUrl(url) {
      window.location.href = url;
    },
    getLists() {
      const sortType = Cookies.get("category_ui_sortType");
      if (sortType != undefined) {
        this.sort = sortType;
      }
      this.$http
        .post(
          `/apiserv/qTLN2Nec/Frontend/Classify/V2/Games?uuid=${this.uuid}&sortType=${this.sort}&tags=${this.tags}&pageIndex=1&pageSize=50`
        )
        .then(res => {
          // this.$http.post(`http://easymock.233wei.cn/mock/5e3919a47967af073af3f84a/qTLN2Nec/Frontend/Classify/V2/Games#!method=post`).then(res => {
          if (res.data.return_code === 200 && res.data.data) {
            const reqId = res.data.data.reqId;
            const recData = reqId ? res.data.data.recData : res.data.data;
            this.resId = {
              ...this.resId,
              reqId: reqId || "",
              param2: parseInt(`${this.choosedCategory + 1}${this.choosedSortType + 1}`) ,
            };
            recData.games.forEach(i => {
              this.index = this.index + 1;
              i.index = this.index;
            });
            this.gameList = recData.games;
            // 发送 resId 埋点
            setTimeout(() => {
              const screenHeight = window.screen.height;
              const headerHeight = this.$refs.header.clientHeight + this.$refs.sortList.clientHeight;
              const gameItem = this.$refs.gameItem ? this.$refs.gameItem[0] : { $el: {} };
              const gameHeight = gameItem.$el.clientHeight || 95;
              const gameIndex = Math.floor((screenHeight - headerHeight) / gameHeight);
              const params = { ...this.resId };
              for (let i = 0; i < gameIndex && i < recData.games.length; i++) {
                params.paramExtra = (i + 1).toString();
                params.gameId = recData.games[i].id.toString();
                collect('item_show', changeResId(params), '分类页')
              }
              this.screenHeight = screenHeight;
              this.headerHeight = headerHeight;
              this.gameIndex = gameIndex;
            }, 100);
          }
        });
    },
    changeCategory(index, categoryId, tags) {
      this.choosedCategory = index;
      this.isMoreListShow = false;
      if (this.tags == tags) {
        return;
      } else {
        this.tags = tags;
        this.getLists();
      }
      this.$nextTick(() => {
        if (this.$refs[categoryId]) {
          this.$refs[categoryId][0].scrollIntoView({
            behavior: "smooth",
            inline: "start",
            block: "end"
          });
        }
      });
    },
    sortType(index) {
      this.choosedSortType = index;
      if (this.sort == index + 1) {
        return;
      } else {
        this.sort = index + 1;
        Cookies.set("category_ui_sortType", this.sort, {
          expires: 1 / 480
        });
        this.getLists();
      }
    },
    moreList() {
      this.isMoreListShow = true;
    },
    clickPkg() {
      this.isSizeShow = !this.isSizeShow;
      this.isShade = !this.isShade;
      this.isModalShow = !this.isModalShow;
      this.choosedPkgType = !this.choosedPkgType;
    },
    clickPkgFloat() {
      this.isSizeShowFloat = !this.isSizeShowFloat;
      this.isShade = !this.isShade;
      this.isModalShow = !this.isModalShow;
      this.choosedPkgType = !this.choosedPkgType;
    },
    changePkg(pkg) {
      this.choosedPkg = pkg;
      this.isShade = false;
      this.isModalShow = false;
      this.choosedPkgType = false;
      this.isSizeShow = false;
      this.isSizeShowFloat = false;
    },
    switchModal() {
      this.isShade = false;
      this.isModalShow = false;
      this.choosedPkgType = false;
      this.isSizeShow = false;
    },
    closeListModal() {
      this.isMoreListShow = false;
    },
    scrollEvent(e) {
      const curHeight = e.target.scrollTop;
      if (!this.gameHeight) {
        this.gameHeight = this.$refs.gameItem[0].$el.clientHeight;
      }
      const gameHeight  = this.gameHeight;
      const screenHeight  = this.screenHeight;
      const headerHeight  = this.headerHeight;
      const gameIndex = this.gameIndex;
      const index = Math.floor((screenHeight + curHeight - headerHeight) / gameHeight);
      if (index > gameIndex) {
        // 完全显示之后发送 resId
        this.gameIndex = index;
        const gameItem = this.$refs.gameItem[index - 1];
        if(gameItem){
          const params = { ...this.resId, param1: index, gameId: gameItem.game.gameId.toString() };
          collect('item_show', changeResId(params), '搜索-结果页');
        }
      }
      Cookies.set(`category_ui_scroll_${window.location.href}`, curHeight, {
        expires: 1 / 480
      });
    }
  }
};
</script>
<style lang='less' scoped>
.categoryRapper {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  header {
    height: 0.5rem;
    display: flex;
    padding: 0.166rem;
    background: #fff;
    position: relative;
    z-index: 999;
    > :nth-child(1) {
      flex: 1;
      display: flex;
      align-items: center;
      img {
        width: 0.25rem;
        height: 0.25rem;
        margin-left: -0.05rem;
      }
    }
    > :nth-child(2) {
      flex: 3;
      text-align: center;
      line-height: 0.168rem;
      font-size: 0.19rem;
      font-weight: 400;
      color: rgba(27, 27, 27, 1);
    }
    > :nth-child(3) {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      img {
        width: 0.25rem;
        height: 0.25rem;
      }
    }
  }
  .content {
    overflow-y: scroll;
    flex: 1;
    .banner {
      padding-top: 0.16rem;
      margin-left: 0.166rem;
      margin-right: 0.166rem;
      height: 1.49rem;
    }
    .banner-anim {
      animation: myheight 0.5s;
    }
    @keyframes myheight {
      0% {
        height: 0;
      }
      25% {
        height: 0.3rem;
      }
      50% {
        height: 0.6rem;
      }
      75% {
        height: 0.9rem;
      }
      100% {
        height: 1.33rem;
      }
    }
    .listAni {
      height: 0rem;
      margin-top: -0.2rem !important;
      animation: listheight 0.05s;
    }
    @keyframes listheight {
      0% {
        height: 0.18rem;
      }
      25% {
        height: 0.12rem;
      }
      50% {
        height: 0.06rem;
      }
      100% {
        height: 0rem;
      }
    }
    .gameBox {
      padding: 0.12rem 0.17rem 0.07rem 0.17rem;
      .gameTypeBox {
        position: relative;
        width: 3.16rem;
        // width: 100%;
        margin-right: 0.25rem;
        // padding-right: 0.42rem;
        .gameList {
          position: relative;
          overflow-x: scroll;
          .category {
            width: max-content;
            height: 0.36rem;
            li {
              display: inline-block;
              margin-right: 0.21rem;
              line-height: 0.36rem;
              position: relative;
              font-size: 0.15rem;
              font-weight: 400;
              color: #333;
            }
            .categoryActive {
              font-size: 0.19rem;
              font-weight: 600;
              color: rgba(27, 27, 27, 1);
              z-index: 2;
              .chooseLine {
                position: absolute;
                bottom: 0;
                left: 50%;
                width: 0.08rem;
                height: 0.02rem;
                margin-left: -0.04rem;
                background: #ff5000;
              }
            }
          }
        }
        .gradual {
          width: 0.29rem;
          height: 0.36rem;
          position: absolute;
          right: 0rem;
          bottom: 0;
          pointer-events: none;
          background-image: linear-gradient(
            to right,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 1)
          );
        }
        .listImg {
          position: absolute;
          right: -0.25rem;
          bottom: 0.02rem;
          z-index: 5;
          width: 0.25rem;
          height: 0.29rem;
          img {
            width: 0.25rem;
            height: 0.29rem;
          }
        }
      }
    }
    .sortList {
      position: sticky;
      top: 0;
      height: 0.46rem;
      font-size: 0.13rem;
      padding: 0.13rem 0.166rem 0.08rem 0.166rem;
      background: #fff;
      z-index: 6;
      .shade {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0);
        z-index: 7;
      }
      .chooseSize {
        position: absolute;
        top: 0.8rem;
        right: 0.15rem;
        z-index: 6;
        width: 1.58rem;
        height: 2.67rem;
        background: #fff;
        box-shadow: 0px 0.01rem 0.1rem 0px rgba(0, 0, 0, 0.08);
        border-radius: 0.13rem;
        li {
          height: 0.42rem;
          line-height: 0.42rem;
          text-align: center;
          font-size: 0.13rem;
          color: #262626;
        }
        .chooseSizeActive {
          color: #ff5000;
          font-weight: 500;
        }
      }
      > li {
        width: 0.58rem;
        height: 0.25rem;
        line-height: 0.25rem;
        border-radius: 0.13rem;
        background: #f5f5f5;
        color: #333;
        float: left;
        text-align: center;
        margin-right: 0.1rem;
        img {
          width: 0.08rem;
          height: 0.04rem;
        }
        &.pkgLi {
          width: 0.96rem;
          height: 0.25rem;
          float: right;
          margin-right: 0;
          position: relative;
        }
      }
      .tagActive {
        color: #ff5000;
        background: rgba(255, 80, 1, 0.1);
        font-weight: 600;
      }
    }
    .gameListBox {
      overflow-y: scroll;
      height: 100%;
      color: #999;
      font-size: 0.13rem;
      padding: 0 0.166rem 0.1666rem 0.166rem;
    }
  }
  > .sortList {
    position: fixed;
    top: 0.5rem;
    left: 0;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.08);
    width: 100%;
    height: 0.46rem;
    font-size: 0.13rem;
    padding: 0.13rem 0.166rem 0.08rem 0.166rem;
    background: #fff;
    z-index: 6;
    .shade {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(255, 255, 255, 0);
      z-index: 7;
    }
    .chooseSize {
      position: absolute;
      top: 1rem;
      right: 0.2rem;
      z-index: 6;
      width: 1.58rem;
      height: 2.67rem;
      background: #fff;
      box-shadow: 0px 0.01rem 0.1rem 0px rgba(0, 0, 0, 0.08);
      border-radius: 0.13rem;
      li {
        height: 0.42rem;
        line-height: 0.42rem;
        text-align: center;
        font-size: 0.13rem;
        color: #262626;
      }
      .chooseSizeActive {
        color: #ff5000;
        font-weight: 500;
      }
    }
    > li {
      width: 0.58rem;
      height: 0.25rem;
      line-height: 0.25rem;
      border-radius: 0.13rem;
      background: #f5f5f5;
      color: #333;
      float: left;
      text-align: center;
      margin-right: 0.1rem;
      img {
        width: 0.08rem;
        height: 0.04rem;
      }
      &:last-of-type {
        width: 0.96rem;
        height: 0.25rem;
        float: right;
        margin-right: 0;
        position: relative;
      }
    }
    .tagActive {
      color: #ff5000;
      background: rgba(255, 80, 1, 0.1);
      font-weight: 600;
    }
  }
  .closePkgModal {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0);
    position: absolute;
    left: 0;
    top: 0;
    z-index: 5;
  }
  .moreList {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 8;
    .modal {
      width: 40%;
      height: 100%;
      background: rgba(0, 0, 0, 0.65);
      position: fixed;
      top: 0.5rem;
      left: 0;
    }
    .moreChoose {
      width: 60%;
      height: 100%;
      background: #fff;
      position: fixed;
      top: 0.5rem;
      right: 0;
      > h3 {
        color: #1b1b1b;
        height: 0.26rem;
        line-height: 0.26rem;
        margin-top: 0.55rem;
        font-weight: 600;
        text-align: center;
        font-size: 0.19rem;
      }
      ul {
        margin-top: 0.15rem;
        li {
          width: 0.81rem;
          height: 0.33rem;
          line-height: 0.33rem;
          text-align: center;
          background: #f5f5f5;
          border-radius: 0.17rem;
          float: left;
          margin: 0 0 0.21rem 0.17rem;
        }
        .categoryActive {
          color: #ff5000;
          background: rgba(255, 80, 1, 0.15);
        }
      }
    }
  }
}
</style>
